import { makeAutoObservable } from "mobx";

import { WhitelabelSettingReadModel } from "../../@api";

export class WhitelabelStore {
  private _whitelabelSettings: WhitelabelSettingReadModel[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  public get whitelabelSettings(): WhitelabelSettingReadModel[] {
    return this._whitelabelSettings;
  }

  public set whitelabelSettings(settings: WhitelabelSettingReadModel[]) {
    this._whitelabelSettings = settings;
  }

  public get appLogo(): Blob | undefined {
    return undefined;
  }
}
